import { render, staticRenderFns } from "./value-item.vue?vue&type=template&id=5a98a1e0&scoped=true"
import script from "./value-item.vue?vue&type=script&lang=js"
export * from "./value-item.vue?vue&type=script&lang=js"
import style0 from "./value-item.vue?vue&type=style&index=0&id=5a98a1e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a98a1e0",
  null
  
)

export default component.exports